import { Skeleton as AntSkeleton } from 'antd';

export function Skeleton({ lines = 3 }: { lines?: number }) {
  return (
    <div className="card" aria-busy="true" role="status" aria-label="Loading">
      <div className="card-body"><AntSkeleton active paragraph={{ rows: Math.max(1, lines - 1) }} /></div>
    </div>
  );
}
